const doc = [({"da":({"js":({"admin":({"organizations":({"index":({"add_new_organization":"Tilføj ny organisation", "the_organization_was_deleted":"Organisationen blev slettet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;